import React, { MouseEvent } from 'react';
import useModifiers from 'hooks/useModifiers';

export enum BtnModifier {
  BIG = 'big',
  SMALL = 'small',
  SCROLL_TOP = 'scrollTop',
  TABLE_LINK = 'tableLink',
  OLD = 'old',
  OUTLINED_BACKGROUND = 'outlinedBackground',
  INNER = 'inner',
  INTEGRATION = 'integration',
  OVERVIEW_SIDE = 'overviewSide',
  VALIDATION_FILTER = 'validationFilter',
  NO_PADDING = 'noPadding',
  GRAYED_OUT = 'grayedOut',
  NICE_BUTTON_CLASSIC = 'niceButtonClassic',
  NO_HEIGHT = 'noHeight',
  BORDER = 'border',
  IMPORTS = 'imports',
}

export interface BtnProps {
  type: 'primary' | 'secondary' | 'link';
  btnType?: 'submit' | 'reset' | 'button' | undefined;
  iconRight?: boolean;
  icon?: React.ReactElement;
  text?: string;
  modifier?: BtnModifier[];
  disabled?: boolean;
  onClick?: (e?: MouseEvent) => void;
}

function Btn(props: BtnProps) {
  let modifier: BtnModifier[] = (props.modifier === undefined) ? [] : props.modifier;
  if (props.disabled) {
    modifier.push(BtnModifier.GRAYED_OUT);
  }
  const mods = useModifiers(modifier);
  const icon = props.icon || '';
  const text = props.text ? (<span>{props.text}</span>) : '';

  return (
    <button
      disabled={props.disabled}
      onClick={props.onClick}
      // eslint-disable-next-line react/button-has-type
      type={props.btnType}
      className={`ct_btn _${props.type} ${mods}`}
    >
      {!props.iconRight ? icon : ''}
      {text}
      {props.iconRight ? icon : ''}
    </button>
  );
}

Btn.defaultProps = { ...{} };

export default Btn;
